import { Button } from "@/components/ui/button"
import { Company } from "@/types/company"
import { Download, Mail, Table, X } from "lucide-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Badge } from "../ui/badge"

interface CompanyTableToolbarProps {
  selectedCompanies: Company[]
  onSendEmail: () => void
  onExportExcel: () => void
  onExportPdf: () => void
  clearSelection: () => void
}

export function CompanyTableToolbar({
  selectedCompanies,
  onSendEmail,
  onExportExcel,
  onExportPdf,
  clearSelection,
}: CompanyTableToolbarProps) {
  const selectedCount = selectedCompanies.length

  if (selectedCount === 0) return null

  return (
    <div className="flex items-center gap-2 p-4 bg-muted/50 rounded-lg mb-4">
      <div className="flex-1 flex items-center gap-2">
        <Badge variant="secondary" className="px-2 py-1">
          {selectedCount} firma seçildi
        </Badge>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={clearSelection} 
          className="h-8"
        >
          <X className="h-3.5 w-3.5 mr-1.5" />
          Seçimleri Temizle
        </Button>
      </div>
      
      <Button variant="outline" size="sm" onClick={onSendEmail}>
        <Mail className="h-4 w-4 mr-2" />
        Toplu Mail
      </Button>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm">
            <Download className="h-4 w-4 mr-2" />
            Dışa Aktar
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={onExportExcel}>
            <Table className="h-4 w-4 mr-2" />
            Excel'e Aktar
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onExportPdf}>
            <Download className="h-4 w-4 mr-2" />
            PDF'e Aktar
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
